module.exports = __webpack_public_path__ + "img/icon_innerLinkUniv.cb06b055.svg";